import {Pipe, PipeTransform} from "@angular/core";
import {UtilitiesService} from "../../core/_services/utilities.service";

@Pipe ({name: 'listStrings'})
export class ListStringsPipe implements PipeTransform {

    transform(list: Object[], listProperty: string): string {
        // require a non-empty list of objects (any type) and a listProperty
        if (UtilitiesService.isEmpty(list) || UtilitiesService.isEmpty(listProperty)) {
            return '';
        }

        return list.map(item => item[listProperty]).join(', ');
    } // transform()

} // ListStringsPipe
